import { EUserRoleCode, userManagerApi } from '@/axios/user';
import PaginationSelector from './PaginationSelector';

type Params = Omit<Parameters<typeof userManagerApi.list>[0], 'pageIndex' | 'pageSize'>;

// 提取 records 数组元素的类型
type TaskRecord = Awaited<ReturnType<typeof userManagerApi.list>>['records'][number];

/** 用户选择器 */
const UserSelector = ({
  params,
  placeholder = '请选择用户',
  value,
  onChange,
  multiple = false,
}: {
  params: Omit<Parameters<typeof userManagerApi.list>[0], 'pageIndex' | 'pageSize'>;
  placeholder?: string;
  value?: string | string[];
  onChange?: (value: string | string[]) => void;
  multiple?: boolean;
}) => {
  return (
    <PaginationSelector<TaskRecord, Params>
      fetchApi={(params) => userManagerApi.list(params)}
      params={params}
      optionTransform={(item) => ({
        value: item.userId?.toString() || '',
        label: item.nickname || item.email || '',
      })}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      multiple={multiple}
    />
  );
};
export default UserSelector;
